<template>
  <div>
    <el-row :gutter="10" class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="10" :md="10">
        <el-input v-model="filtro.termo" :placeholder="placeholderBusca" clearable
                  @keyup.native.enter="load" @clear="load"></el-input>
      </el-col>

      <el-col :xs="24" :sm="6" :md="6" v-if="filtroExtra">
        <el-select v-model="filtro[filtroExtra.chave]" :placeholder="filtroExtra.label" clearable
                   @change="load" style="width:100%">
          <el-option v-for="o in filtroExtra.opcoes" :key="o.valor" :label="o.rotulo" :value="o.valor"></el-option>
        </el-select>
      </el-col>

      <el-col :xs="24" :sm="filtroExtra ? 8 : 14" class="u-text-right">
        <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
        <el-button v-if="podeEscrever" type="primary" icon="el-icon-plus" @click="abrirNovo">
          {{ rotuloNovo }}
        </el-button>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th v-for="c in colunas" :key="c.chave" :style="c.largura ? 'width:' + c.largura : ''"
                :class="c.mobileOculto ? 'hidden-mobile' : ''">{{ c.label }}</th>
            <th class="hidden-mobile u-text-center" style="width: 80px;">Ativo</th>
            <th style="width: 130px;" class="u-text-center" v-if="podeEscrever">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td v-for="c in colunas" :key="c.chave" :class="c.mobileOculto ? 'hidden-mobile' : ''">
              {{ formatar(item, c) }}
            </td>
            <td class="hidden-mobile u-text-center">{{ item.situacao ? 'SIM' : 'NÃO' }}</td>
            <td class="u-text-center acao" v-if="podeEscrever">
              <el-button @click="abrirEdicao(item)" title="Editar" type="info"
                         icon="el-icon-edit" size="mini" plain class="u-mr-10"></el-button>
              <el-button @click="excluir(item)" title="Excluir" type="danger"
                         icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
          <tr v-if="items.length === 0">
            <td :colspan="colunas.length + (podeEscrever ? 3 : 2)" class="u-text-center">
              Nenhum registro encontrado.
            </td>
          </tr>
        </tbody>
      </table>

      <el-row v-if="statusList">
        <el-col :xs="24" :sm="12">
          <div class="u-mt-10">
            <small v-if="paginate.qtdItens">Exibindo {{ paginate.from }} a {{ paginate.to }} de {{ paginate.qtdItens }}</small>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > paginate.porPagina">
          <div class="u-text-right">
            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                           @current-change="irParaPagina" :page-size="paginate.porPagina"
                           background layout="prev, pager, next" small></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- Formulário em diálogo: o cadastro é curto e quase sempre aberto a partir da lista. -->
    <el-dialog :title="dialogTitulo" :visible.sync="dialogAberto" :width="dialogLargura" append-to-body>
      <el-form :model="form" label-position="top">
        <el-row :gutter="10">
          <el-col v-for="c in campos" :key="c.chave"
                  :xs="24" :sm="c.span || 12">
            <el-form-item :label="c.label + (c.obrigatorio ? ' *' : '')">
              <el-select v-if="c.tipo === 'select'" v-model="form[c.chave]" :clearable="!c.obrigatorio"
                         :placeholder="c.label" style="width:100%" filterable>
                <el-option v-for="o in (c.opcoes || opcoesDinamicas[c.chave] || [])" :key="o.valor"
                           :label="o.rotulo" :value="o.valor"></el-option>
              </el-select>

              <el-input v-else-if="c.tipo === 'textarea'" v-model="form[c.chave]" type="textarea"
                        :rows="c.linhas || 3" :maxlength="c.max"></el-input>

              <el-input v-else-if="c.tipo === 'numero'" v-model="form[c.chave]" type="number"></el-input>

              <el-input v-else v-model="form[c.chave]" :maxlength="c.max"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12">
            <el-form-item label="Ativo">
              <el-switch v-model="form.situacao"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button @click="dialogAberto = false">CANCELAR</el-button>
        <el-button class="u-ml-10" type="primary" @click="salvar" :loading="salvando">SALVAR</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * BLOCO X — CRUD genérico dos catálogos de REDE da Biblioteca.
 *
 * Sete cadastros do edital (autor, editora, idioma, assunto, coleção, classificação e cutter)
 * têm exatamente a mesma mecânica: listar com busca, criar, editar, inativar, excluir. Sete
 * telas quase idênticas seriam sete lugares para o mesmo defeito aparecer.
 *
 * O que muda entre eles são os CAMPOS e as COLUNAS — e é isso que cada tela passa por prop.
 *
 * A regra de quem escreve é do BACKEND (`BibliotecaCatalogoService`). `podeEscrever` aqui só
 * decide se o botão aparece: esconder botão não é segurança, e o Service recusa de qualquer
 * forma. Ele existe para não oferecer ao operador uma ação que vai falhar.
 */
export default {
  name: 'CatalogoCrud',

  props: {
    /** autor | editora | idioma | assunto | colecao | classificacao | cutter */
    tipo: { type: String, required: true },

    rotuloNovo: { type: String, default: 'NOVO' },

    nomeSingular: { type: String, default: 'registro' },

    placeholderBusca: { type: String, default: 'Pesquisar' },

    /** [{chave, label, tipo, obrigatorio, opcoes, span, max, linhas}] */
    campos: { type: Array, required: true },

    /** [{chave, label, largura, mobileOculto, mapa}] */
    colunas: { type: Array, required: true },

    /** Filtro adicional na barra: {chave, label, opcoes} */
    filtroExtra: { type: Object, default: null },

    /** Perfis que o backend aceita para escrita — espelho da matriz, não a regra. */
    perfisEscrita: { type: Array, default: () => [4, 5, 7] },

    dialogLargura: { type: String, default: '620px' }
  },

  data () {
    return {
      statusList: false,
      items: [],
      filtro: { termo: '' },
      paginate: { page: 1, qtdItens: null, from: '', to: '', porPagina: 30 },
      dialogAberto: false,
      salvando: false,
      editandoId: null,
      form: {},
      opcoesDinamicas: {}
    }
  },

  computed: {
    podeEscrever () {
      return this.perfisEscrita.indexOf(Number(this.$store.state.user.tipo)) !== -1
    },

    dialogTitulo () {
      return (this.editandoId ? 'Editar ' : 'Novo ') + this.nomeSingular
    },

    base () {
      return `${this.$store.state.config.baseUrlApi}/api/biblioteca/catalogo/${this.tipo}`
    }
  },

  mounted () {
    if (this.filtroExtra) this.$set(this.filtro, this.filtroExtra.chave, '')
    this.load()
    this.carregarOpcoesDinamicas()
  },

  methods: {
    formatar (item, c) {
      const v = item[c.chave]

      // Ausência é ausência: mostra travessão, não string vazia nem zero.
      if (v === null || v === undefined || v === '') return '—'

      if (c.mapa) return c.mapa[v] || v

      return v
    },

    load () {
      this.statusList = false
      this.items = []

      this.$axios.post(`${this.base}/getAllPaginate?page=${this.paginate.page}`,
                       this.filtro, this.$store.getters.getHeaderAuth)
        .then(r => {
          if (r.data && r.data.erro) {
            this.statusList = true
            return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          }

          this.items = r.data.data || []
          this.paginate.qtdItens = r.data.total
          this.paginate.from = r.data.from
          this.paginate.to = r.data.to
          this.statusList = true
        })
        .catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
    },

    /**
     * Alguns campos são select cujas opções vêm do próprio catálogo — hoje, o assunto pai.
     * Buscar aqui evita que cada tela reimplemente a mesma chamada.
     */
    carregarOpcoesDinamicas () {
      const precisa = this.campos.filter(c => c.opcoesDe)

      precisa.forEach(c => {
        this.$axios.post(
          `${this.$store.state.config.baseUrlApi}/api/biblioteca/catalogo/${c.opcoesDe}/getAllPaginate`,
          { per_page: 200 }, this.$store.getters.getHeaderAuth
        ).then(r => {
          if (!r.data || r.data.erro) return

          this.$set(this.opcoesDinamicas, c.chave, (r.data.data || []).map(i => ({
            valor: i.id,
            rotulo: i.descricao || i.nome
          })))
        }).catch(() => {})
      })
    },

    abrirNovo () {
      this.editandoId = null
      const f = { situacao: true }
      this.campos.forEach(c => { f[c.chave] = c.padrao !== undefined ? c.padrao : '' })
      this.form = f
      this.dialogAberto = true
    },

    abrirEdicao (item) {
      this.editandoId = item.id
      const f = { situacao: !!item.situacao }
      this.campos.forEach(c => {
        f[c.chave] = item[c.chave] === null || item[c.chave] === undefined ? '' : item[c.chave]
      })
      this.form = f
      this.dialogAberto = true
    },

    salvar () {
      const faltando = this.campos.filter(c => c.obrigatorio &&
        (this.form[c.chave] === '' || this.form[c.chave] === null || this.form[c.chave] === undefined))

      if (faltando.length) {
        return window.eventBus.$emit('alert', {
          msg: 'Preencha: ' + faltando.map(c => c.label).join(', ') + '.', type: 'warning'
        })
      }

      this.salvando = true

      const url = this.editandoId ? `${this.base}/update/${this.editandoId}` : `${this.base}/store`

      this.$axios.post(url, this.form, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.salvando = false

          // O backend valida de verdade; a recusa precisa chegar ao operador.
          if (r.data && r.data.erro) {
            return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          }

          this.dialogAberto = false
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.load()
          this.carregarOpcoesDinamicas()
        })
        .catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
    },

    excluir (item) {
      this.$msgbox.confirm(`Tem certeza que deseja excluir este ${this.nomeSingular}?`, 'Atenção',
        { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)

          this.$axios.delete(`${this.base}/delete/${item.id}`, this.$store.getters.getHeaderAuth)
            .then(r => {
              window.eventBus.$emit('loading', false)

              if (r.data && r.data.erro) {
                return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
              }

              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            })
            .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        })
        .catch(() => {})
    },

    irParaPagina (page) {
      this.paginate.page = page
      this.load()
    }
  }
}
</script>
